import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  orderItemsTitle: {
    defaultMessage: 'Order Items',
    description: 'Header for the left panel showing unassigned order items',
    id: 'VxUNv7',
  },
  orderItemsInstruction: {
    defaultMessage: 'Drag items to a package to assign them for shipment.',
    description: 'Instruction text explaining how to assign items to packages',
    id: 'gaIXiD',
  },
  orderItemsCaption: {
    defaultMessage: 'Adjust quantities, then drag items to a package.',
    description: 'Caption text reminding users to assign all items before saving',
    id: 'q/bjGH',
  },
  allocationUnavailableHeading: {
    defaultMessage: 'Item allocation unavailable',
    description: 'Heading of the info banner shown when an order has an item with a quantity of 0',
    id: 'dkfwlX',
  },
  allocationUnavailableMessage: {
    defaultMessage:
      'This order contains an item with a quantity of 0, so items cannot be assigned to packages. You can still save your packages and create your label.',
    description: 'Message of the info banner explaining that items cannot be assigned to packages because an item has a quantity of 0',
    id: 'XjhezU',
  },
  allocationOptionalHeading: {
    defaultMessage: 'Item allocation is optional',
    description: 'Heading of the info banner explaining that assigning items to packages is optional',
    id: 'CaBQWm',
  },
  allocationOptionalMessage: {
    defaultMessage: 'You can save without assigning items.',
    description: 'Message of the info banner explaining that packages can be saved without assigning items',
    id: 'd1i37N',
  },
  allItemsAssigned: {
    defaultMessage: 'All Items Assigned!',
    description: 'Success message shown when all items have been assigned to packages',
    id: 'DDNIqR',
  },
});
